const testIds = {
  main: "main",
};

export default testIds;
